import { useParamsStore } from '@/store/local-storage/params';
import type { IHttpResponse } from '@/store/definition';

// S3へファイルアップロード時のタイムアウト秒数（ミリ秒）
const PUT_S3_TIMEOUT = 600000;
export interface IYoienInternalApi {
  // 障害通知情報一覧取得
  getFaultNotificationList(queryParam: any, errorCallback: any): Promise<IHttpResponse>;

  // お知らせ情報一覧取得
  getAnnouncementInformationList(errorCallback: any): Promise<IHttpResponse>;

  // メール通知設定取得
  getSettingEmailNotification(errorCallback: any): Promise<IHttpResponse>;

  // ポップアップ通知設定取得
  getPopupNotificationSettings(errorCallback: any): Promise<IHttpResponse>;

  // 制御グループ一覧取得
  getControlGroupList(errorCallback: any): Promise<IHttpResponse>;

  // 制御グループ詳細取得
  getControlGroups(controlGroupId: number, errorCallback: any): Promise<IHttpResponse>;

  // コンテンツ情報一覧取得
  getContentList(queryParam: any, errorCallback: any): Promise<IHttpResponse>;

  // コンテンツ情報詳細取得
  getContents(contentId: number, errorCallback: any): Promise<IHttpResponse>;

  // シーン情報一覧取得
  getSceneList(queryParam: any, errorCallback: any): Promise<IHttpResponse>;

  // シーン情報詳細取得
  getScenes(sceneId: number, errorCallback: any): Promise<IHttpResponse>;

  // シーン名称情報取得
  getSceneName(controlGroupId: number, queryParam: any, errorCallback: any): Promise<IHttpResponse>;

  // シーン管理状況取得
  getProgress(controlGroupId: number, sceneId: number, errorCallback: any): Promise<IHttpResponse>;

  // シーンサマリ情報一覧取得
  getSceneSummaryList(queryParam: any, errorCallback: any): Promise<IHttpResponse>;

  // スケジュール情報取得
  getSchedules(controlGroupId: number, queryParam: any, errorCallback: any): Promise<IHttpResponse>;

  // カレンダー情報取得
  getCalendars(controlGroupId: number, queryParam: any, errorCallback: any): Promise<IHttpResponse>;

  // ファイル送受信制限状態取得
  getFileRestrictionStatus(errorCallback: any): Promise<IHttpResponse>;

  // データ送信可否取得
  getDataTransmissionAvailability(
    controlGroupId: number,
    queryParam: any,
    errorCallback: any
  ): Promise<IHttpResponse>;

  // データ受信可否取得
  getDataReceptionAvailability(
    controlGroupId: number,
    queryParam: any,
    errorCallback: any
  ): Promise<IHttpResponse>;

  // 使用中コンテンツ一覧取得
  getContentsInUse(queryParam: any, errorCallback: any): Promise<IHttpResponse>;

  // 使用中シーン一覧取得
  getScenesInUse(queryParam: any, errorCallback: any): Promise<IHttpResponse>;

  // 一時ファイルアップロード用URL取得
  getTmpfileUploadUrl(queryParam: any, errorCallback: any): Promise<IHttpResponse>;

  // 祝日設定情報取得
  getHolidaySetting(queryParam: any, errorCallback: any): Promise<IHttpResponse>;

  // データ送受信詳細取得
  getDataTransceiverDetail(queryParam: any, errorCallback: any): Promise<IHttpResponse>;

  // 障害通知情報確認
  putFaultNotifications(body: any, errorCallback: any): Promise<IHttpResponse>;

  // 運用レポート埋め込みURL取得
  getReportEmbedUrl(errorCallback: any): Promise<IHttpResponse>;

  // お知らせ情報更新
  putAnnouncementInformation(body: any, errorCallback: any): Promise<IHttpResponse>;

  // メール通知設定更新
  putSettingEmailNotification(body: any, errorCallback: any): Promise<IHttpResponse>;

  // ポップアップ通知設定更新
  putSettingPopupNotification(body: any, errorCallback: any): Promise<IHttpResponse>;

  // 制御グループ登録
  postControlGroup(body: any, errorCallback: any): Promise<IHttpResponse>;

  // 制御グループ更新
  putControlGroups(controlGroupId: number, body: any, errorCallback: any): Promise<IHttpResponse>;

  // コンテンツ情報登録
  postContent(body: any, errorCallback: any): Promise<IHttpResponse>;

  // コンテンツ情報更新
  putContents(contentId: number, body: any, errorCallback: any): Promise<IHttpResponse>;

  // シーン情報登録
  postScene(controlGroupId: number, body: any, errorCallback: any): Promise<IHttpResponse>;

  // シーン情報更新
  putScenes(
    controlGroupId: number,
    sceneId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse>;

  // シーン管理情報更新
  putScenesInfo(
    controlGroupId: number,
    sceneId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse>;

  // CWシーン管理情報更新
  putCwScenesInfo(controlGroupId: number, body: any, errorCallback: any): Promise<IHttpResponse>;

  // シーン合成情報登録
  postScenesSynthesize(
    controlGroupId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse>;

  // シーン名称情報更新
  putSceneName(controlGroupId: number, body: any, errorCallback: any): Promise<IHttpResponse>;

  // シーン名称管理情報更新
  putSceneNameInfo(controlGroupId: number, body: any, errorCallback: any): Promise<IHttpResponse>;

  // スケジュール情報更新
  putSchedules(controlGroupId: number, body: any, errorCallback: any): Promise<IHttpResponse>;

  // スケジュール管理情報更新
  putSchedulesInfo(controlGroupId: number, body: any, errorCallback: any): Promise<IHttpResponse>;

  // カレンダー情報更新
  putCalendars(controlGroupId: number, body: any, errorCallback: any): Promise<IHttpResponse>;

  // カレンダー管理情報更新
  putCalendarsInfo(controlGroupId: number, body: any, errorCallback: any): Promise<IHttpResponse>;

  // ファイル送受信制限状態更新
  putFileRestrictionStatus(
    body: any,
    updatedAt: string,
    errorCallback: any
  ): Promise<IHttpResponse>;

  // 使用中コンテンツ登録
  postContentsInUse(body: any, errorCallback: any): Promise<IHttpResponse>;

  // 使用中シーン登録
  postScenesInUse(body: any, errorCallback: any): Promise<IHttpResponse>;

  // コントローラ制御要求送信
  putScenario(controlGroupId: number, body: any, errorCallback: any): Promise<IHttpResponse>;

  // メンテナンス要求送信
  putMaintenances(
    controlGroupId: number,
    service: string,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse>;

  // 障害通知情報登録
  postFaultNotification(body: any, errorCallback: any): Promise<IHttpResponse>;

  // ログ出力
  postLogs(body: any, errorCallback: any): Promise<IHttpResponse>;

  // データ送信情報ファイル作成
  postSendFile(body: any, errorCallback: any): Promise<IHttpResponse>;

  // データ受信情報ファイル作成
  postReceiveFile(body: any, errorCallback: any): Promise<IHttpResponse>;

  // データ送受信詳細更新
  putDataTransceiverDetail(body: any, errorCallback: any): Promise<IHttpResponse>;

  // データ送受信バッチ実行メッセージ登録
  postDataTransceiverBatch(
    controlGroupId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse>;

  // 障害通知情報全削除
  deleteFaultNotifications(errorCallback: any): Promise<IHttpResponse>;

  // 制御グループ削除
  deleteControlGroups(
    controlGroupId: number,
    queryParam: any,
    errorCallback: any
  ): Promise<IHttpResponse>;

  // コンテンツ情報削除
  deleteContents(contentId: number, errorCallback: any): Promise<IHttpResponse>;

  // シーン情報削除
  deleteScenes(controlGroupId: number, sceneId: number, errorCallback: any): Promise<IHttpResponse>;

  // スケジュール情報削除
  deleteSchedules(
    controlGroupId: number,
    scheduleNo: number,
    errorCallback: any
  ): Promise<IHttpResponse>;

  // 使用中コンテンツ削除
  deleteContentsInUse(body: any, errorCallback: any): Promise<IHttpResponse>;

  // 使用中シーン削除
  deleteScenesInUse(body: any, errorCallback: any): Promise<IHttpResponse>;

  // 未作成シーンプレビュー開始要求
  postStartRequestNotCreatedScenePreview(
    controlGroupId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse>;

  // 未合成シーンプレビュー開始要求
  postStartRequestNotCompositionScenePreview(
    controlGroupId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse>;

  // 作成済シーンプレビュー開始要求
  postStartRequestCreatedScenePreview(
    controlGroupId: number,
    sceneId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse>;

  // プレビュー終了要求
  deleteRequestEndPreview(streamingProcessId: string, errorCallback: any): Promise<IHttpResponse>;
}

const getYoienHeaderParams = () => {
  const params = useParamsStore();
  const { $generateUUID, $getEnvName, $ENV_NAME, $YOIEN_SERVER_CONFIG } = useNuxtApp();
  const config = useRuntimeConfig();
  let envName = $getEnvName();
  if (envName === $ENV_NAME.LOCAL && config.public.appEnv) {
    envName = config.public.appEnv;
  }
  const headers: any = {};
  headers['x-yoien-version'] = params.yoienVersion;
  headers['x-yoien-client'] = params.yoienClient;
  headers['x-request-id'] = $generateUUID();

  // 環境に応じてx-api-keyを設定
  let apiKey = '';
  switch (envName) {
    case $ENV_NAME.LOCAL:
      apiKey = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.LOCAL_API_KEY;
      break;

    case $ENV_NAME.DEV:
      apiKey = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.DEV_API_KEY;
      break;

    case $ENV_NAME.TEST:
      apiKey = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.TEST_API_KEY;
      break;

    case $ENV_NAME.STG:
      apiKey = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.STG_API_KEY;
      break;

    case $ENV_NAME.PROD:
      apiKey = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.PROD_API_KEY;
      break;

    default:
      apiKey = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.LOCAL_API_KEY;
      break;
  }
  headers['x-api-key'] = apiKey;

  headers['Authorization'] = params.idToken;
  headers['content-type'] = 'application/json; charset=utf-8';
  headers['attached-system-role'] = params.systemRole;
  return headers;
};

class YoienInternalApi implements IYoienInternalApi {
  /**
   * 障害通知情報一覧取得
   *
   * @param errorCallback
   * @returns
   */
  async getFaultNotificationList(queryParam: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.FAULT_NOTIFICATION_LIST.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * お知らせ情報一覧取得
   *
   * @param errorCallback
   * @returns
   */
  async getAnnouncementInformationList(errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.ANNOUNCEMENT_INFORMATION_LIST.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * メール通知設定取得
   *
   * @param errorCallback
   * @returns
   */
  async getSettingEmailNotification(errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SETTING_EMAIL_NOTIFICATION.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * ポップアップ通知設定取得
   *
   * @param errorCallback
   * @returns
   */
  async getPopupNotificationSettings(errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SETTING_POPUP_NOTIFICATION.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * 制御グループ一覧取得
   *
   * @param errorCallback
   * @returns
   */
  async getControlGroupList(errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.CONTROL_GROUP_LIST.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * 制御グループ詳細取得
   *
   * @param controlGroupId
   * @param errorCallback
   * @returns
   */
  async getControlGroups(controlGroupId: number, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.CONTROL_GROUPS.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * コンテンツ情報一覧取得
   *
   * @param queryParam
   * @param errorCallback
   * @returns
   */
  async getContentList(queryParam: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.CONTENT_LIST.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * コンテンツ情報詳細取得
   *
   * @param contentId
   * @param errorCallback
   * @returns
   */
  async getContents(contentId: number, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.CONTENTS.replace(
        '{projectId}',
        params.projectId
      ).replace('{contentId}', contentId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * シーン情報一覧取得
   *
   * @param queryParam
   * @param errorCallback
   * @returns
   */
  async getSceneList(queryParam: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SCENE_LIST.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * シーン情報詳細取得
   *
   * @param sceneId
   * @param errorCallback
   * @returns
   */
  async getScenes(sceneId: number, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SCENES.replace(
        '{projectId}',
        params.projectId
      ).replace('{sceneId}', sceneId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * シーン名称情報取得
   *
   * @param controlGroupId
   * @param queryParam
   * @param errorCallback
   * @returns
   */
  async getSceneName(
    controlGroupId: number,
    queryParam: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SCENENAME.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * シーン管理状況取得
   *
   * @param controlGroupId
   * @param sceneId
   * @param errorCallback
   * @returns
   */
  async getProgress(
    controlGroupId: number,
    sceneId: number,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.PROGRESS.replace('{projectId}', params.projectId)
        .replace('{controlGroupId}', controlGroupId.toString())
        .replace('{sceneId}', sceneId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * シーンサマリ情報一覧取得
   *
   * @param queryParam
   * @param errorCallback
   * @returns
   */
  async getSceneSummaryList(queryParam: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SCENE_SUMMARY_LIST.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * スケジュール情報取得
   *
   * @param controlGroupId
   * @param queryParam
   * @param errorCallback
   * @returns
   */
  async getSchedules(
    controlGroupId: number,
    queryParam: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SCHEDULES.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * スケジュール制御グループ管理情報取得
   *
   * @param scheduleNo
   * @param errorCallback
   * @returns
   */
  async getSchedulesControlGroup(scheduleNo: number, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SCHEDULES_CONTROL_GROUP.replace(
        '{projectId}',
        params.projectId
      ).replace('{scheduleNo}', scheduleNo.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      {},
      maxRetryCount,
      errorCallback
    );

    return response;
  }
  /**
   * カレンダー情報取得
   *
   * @param controlGroupId
   * @param queryParam
   * @param errorCallback
   * @returns
   */
  async getCalendars(
    controlGroupId: number,
    queryParam: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.CALENDARS.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * ファイル送受信制限状態取得
   *
   * @param errorCallback
   * @returns
   */
  async getFileRestrictionStatus(errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.FILE_RESTRICTION_STATUS.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * データ送信可否取得
   *
   * @param controlGroupId
   * @param queryParam
   * @param errorCallback
   * @returns
   */
  async getDataTransmissionAvailability(
    controlGroupId: number,
    queryParam: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.DATA_TRANSMISSION_AVAILABILITY.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * データ受信可否取得
   *
   * @param controlGroupId
   * @param queryParam
   * @param errorCallback
   * @returns
   */
  async getDataReceptionAvailability(
    controlGroupId: number,
    queryParam: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.DATA_RECEPTION_AVAILABILITY.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * データ送受信可否取得
   *
   * @param controlGroupId
   * @param queryParam
   * @param errorCallback
   * @returns
   */
  async getDataTransferAvailability(
    controlGroupId: number,
    queryParam: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.DATA_TRANSFER_AVAILABILITY.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * 使用中コンテンツ一覧取得
   *
   * @param errorCallback
   * @returns
   */
  async getContentsInUse(queryParam: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.CONTENTS_IN_USE.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * 使用中シーン一覧取得
   *
   * @param errorCallback
   * @returns
   */
  async getScenesInUse(queryParam: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SCENES_IN_USE.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * 一時ファイルアップロード用URL取得
   *
   * @param queryParam
   * @param errorCallback
   * @returns
   */
  async getTmpfileUploadUrl(queryParam: any, errorCallback: any): Promise<IHttpResponse> {
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url = $getApiUrl() + $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.TMPFILE_UPLOAD_URL;

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * 祝日設定情報取得
   *
   * @param queryParam
   * @param errorCallback
   * @returns
   */
  async getHolidaySetting(queryParam: any, errorCallback: any): Promise<IHttpResponse> {
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url = $getApiUrl() + $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.HOLIDAY_SETTING;

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * データ送受信詳細取得
   *
   * @param queryParam
   * @param errorCallback
   * @returns
   */
  async getDataTransceiverDetail(queryParam: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.DATA_TRANSCEIVER_DETAIL.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * 障害通知情報確認
   *
   * @param body
   * @param errorCallback
   * @returns
   */
  async putFaultNotifications(body: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.FAULT_NOTIFICATION_PUT.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.put(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * 運用レポート埋め込みURL取得
   *
   * @param queryParam
   * @param errorCallback
   * @returns
   */
  async getReportEmbedUrl(errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.REPORT_EMBED_URL.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.get(
      url,
      headersParam,
      queryParam,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * お知らせ情報更新
   *
   * @param body
   * @param errorCallback
   * @returns
   */
  async putAnnouncementInformation(body: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.ANNOUNCEMENT_INFORMATION_REGIST_PUT.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.put(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * メール通知設定更新
   *
   * @param body
   * @param errorCallback
   * @returns
   */
  async putSettingEmailNotification(body: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SETTING_EMAIL_NOTIFICATION_PUT.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.put(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * ポップアップ通知設定更新
   *
   * @param body
   * @param errorCallback
   * @returns
   */
  async putSettingPopupNotification(body: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SETTING_POPUP_NOTIFICATION_PUT.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.put(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * S3ファイルアップロード
   *
   * @param token
   * @param url
   * @param body
   * @param errorCallback
   * @returns
   */
  async putS3File(url: string, body: any, errorCallback: any): Promise<IHttpResponse> {
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper } = useNuxtApp();

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.put(
      url,
      {},
      queryParam,
      body,
      maxRetryCount,
      errorCallback,
      PUT_S3_TIMEOUT
    );

    return response;
  }

  /**
   * 制御グループ登録
   *
   * @param body
   * @param errorCallback
   * @returns
   */
  async postControlGroup(body: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.CONTROL_GROUP_REGIST_POST.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.post(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * 制御グループ更新
   *
   * @param controlGroupId
   * @param body
   * @param errorCallback
   * @returns
   */
  async putControlGroups(
    controlGroupId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.CONTROL_GROUPS_PUT.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.put(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * コンテンツ情報登録
   *
   * @param body
   * @param errorCallback
   * @returns
   */
  async postContent(body: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.CONTENT_REGIST_POST.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.post(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * コンテンツ情報更新
   *
   * @param contentId
   * @param body
   * @param errorCallback
   * @returns
   */
  async putContents(contentId: number, body: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.CONTENTS_PUT.replace(
        '{projectId}',
        params.projectId
      ).replace('{contentId}', contentId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.put(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * シーン情報登録
   *
   * @param controlGroupId
   * @param body
   * @param errorCallback
   * @returns
   */
  async postScene(controlGroupId: number, body: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SCENE_REGIST_POST.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.post(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * シーン情報更新
   *
   * @param controlGroupId
   * @param sceneId
   * @param body
   * @param errorCallback
   * @returns
   */
  async putScenes(
    controlGroupId: number,
    sceneId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SCENES_PUT.replace(
        '{projectId}',
        params.projectId
      )
        .replace('{controlGroupId}', controlGroupId.toString())
        .replace('{sceneId}', sceneId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.put(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * シーン管理情報更新
   *
   * @param controlGroupId
   * @param sceneId
   * @param body
   * @param errorCallback
   * @returns
   */
  async putScenesInfo(
    controlGroupId: number,
    sceneId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SCENES_INFO_PUT.replace(
        '{projectId}',
        params.projectId
      )
        .replace('{controlGroupId}', controlGroupId.toString())
        .replace('{sceneId}', sceneId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.put(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * CWシーン管理情報更新
   *
   * @param controlGroupId
   * @param body
   * @param errorCallback
   * @returns
   */
  async putCwScenesInfo(
    controlGroupId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.CW_SCENES_INFO_PUT.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.put(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * シーン合成情報登録
   *
   * @param controlGroupId
   * @param body
   * @param errorCallback
   * @returns
   */
  async postScenesSynthesize(
    controlGroupId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SCENES_SYNTHESIZE_POST.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.post(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * シーン名称情報更新
   *
   * @param controlGroupId
   * @param body
   * @param errorCallback
   * @returns
   */
  async putSceneName(
    controlGroupId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SCENENAME_PUT.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.put(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * シーン名称管理情報更新
   *
   * @param controlGroupId
   * @param body
   * @param errorCallback
   * @returns
   */
  async putSceneNameInfo(
    controlGroupId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SCENENAME_INFO_PUT.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.put(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * スケジュール情報更新
   *
   * @param controlGroupId
   * @param body
   * @param errorCallback
   * @returns
   */
  async putSchedules(
    controlGroupId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SCHEDULES_PUT.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.put(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * スケジュール管理情報更新
   *
   * @param controlGroupId
   * @param body
   * @param errorCallback
   * @returns
   */
  async putSchedulesInfo(
    controlGroupId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SCHEDULES_INFO_PUT.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.put(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * カレンダー情報更新
   *
   * @param controlGroupId
   * @param body
   * @param errorCallback
   * @returns
   */
  async putCalendars(
    controlGroupId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.CALENDARS_PUT.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.put(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * カレンダー管理情報更新
   *
   * @param controlGroupId
   * @param body
   * @param errorCallback
   * @returns
   */
  async putCalendarsInfo(
    controlGroupId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.CALENDARS_INFO_PUT.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.put(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * ファイル送受信制限状態更新
   *
   * @param body
   * @param errorCallback
   * @returns
   */
  async putFileRestrictionStatus(
    body: any,
    updatedAt: string,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.FILE_RESTRICTION_STATUS_PUT.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    headersParam['x-yoien-max-updated-at'] = updatedAt;
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.put(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * 使用中コンテンツ登録
   *
   * @param body
   * @param errorCallback
   * @returns
   */
  async postContentsInUse(body: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.CONTENTS_IN_USE_POST.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.post(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * 使用中シーン登録
   *
   * @param body
   * @param errorCallback
   * @returns
   */
  async postScenesInUse(body: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SCENES_IN_USE_POST.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.post(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * コントローラ制御要求送信
   *
   * @param controlGroupId
   * @param body
   * @param errorCallback
   * @returns
   */
  async putScenario(controlGroupId: number, body: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SCENARIO_PUT.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.putConnectionTimeoutNotRetry(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * メンテナンス要求送信
   *
   * @param controlGroupId
   * @param body
   * @param errorCallback
   * @returns
   */
  async putMaintenances(
    controlGroupId: number,
    service: string,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.MAINTENANCES_PUT.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {
      service: service,
    };

    const response: Promise<IHttpResponse> = $ApiWrapper.putConnectionTimeoutNotRetry(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * 障害通知情報登録
   *
   * @param body
   * @param errorCallback
   * @returns
   */
  async postFaultNotification(body: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.FAULT_NOTIFICATION_POST.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.post(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * ログ出力
   *
   * @param body
   * @param errorCallback
   * @returns
   */
  async postLogs(body: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.LOGS_POST.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.post(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * データ送信情報ファイル作成
   *
   * @param body
   * @param errorCallback
   * @returns
   */
  async postSendFile(body: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SEND_FILE_POST.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.post(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * データ受信情報ファイル作成
   *
   * @param body
   * @param errorCallback
   * @returns
   */
  async postReceiveFile(body: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.RECEIVE_FILE_POST.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.post(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * データ送受信詳細更新
   *
   * @param body
   * @param errorCallback
   * @returns
   */
  async putDataTransceiverDetail(body: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.DATA_TRANSCEIVER_DETAIL_PUT.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.put(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * データ受信情報ファイル作成
   *
   *
   * @param body
   * @param errorCallback
   * @returns
   */
  async postDataTransceiverBatch(
    controlGroupId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.DATA_TRANSCEIVER_BATCH_POST.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.post(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * 障害通知情報全削除
   *
   * @param errorCallback
   * @returns
   */
  async deleteFaultNotifications(errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.FAULT_NOTIFICATIONS_DELETE.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};
    const body = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.delete(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * 制御グループ削除
   *
   * @param controlGroupId
   * @param queryParam
   * @param errorCallback
   * @returns
   */
  async deleteControlGroups(
    controlGroupId: number,
    queryParam: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.CONTROL_GROUPS_DELETE.replace(
        '{projectId}',
        params.projectId
      ).replace('{controlGroupId}', controlGroupId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const body = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.delete(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * コンテンツ情報削除
   *
   * @param contentId
   * @param errorCallback
   * @returns
   */
  async deleteContents(contentId: number, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.CONTENTS_DELETE.replace(
        '{projectId}',
        params.projectId
      ).replace('{contentId}', contentId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};
    const body = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.delete(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * シーン情報削除
   *
   * @param controlGroupId
   * @param sceneId
   * @param errorCallback
   * @returns
   */
  async deleteScenes(
    controlGroupId: number,
    sceneId: number,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SCENES_DELETE.replace(
        '{projectId}',
        params.projectId
      )
        .replace('{controlGroupId}', controlGroupId.toString())
        .replace('{sceneId}', sceneId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};
    const body = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.delete(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * スケジュール情報削除
   *
   * @param controlGroupId
   * @param scheduleNo
   * @param errorCallback
   * @returns
   */
  async deleteSchedules(
    controlGroupId: number,
    scheduleNo: number,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SCHEDULES_DELETE.replace(
        '{projectId}',
        params.projectId
      )
        .replace('{controlGroupId}', controlGroupId.toString())
        .replace('{scheduleNo}', scheduleNo.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};
    const body = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.delete(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * 使用中コンテンツ削除
   *
   * @param body
   * @param errorCallback
   * @returns
   */
  async deleteContentsInUse(body: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.CONTENTS_IN_USE_DELETE.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.delete(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * 使用中シーン削除
   *
   * @param body
   * @param errorCallback
   * @returns
   */
  async deleteScenesInUse(body: any, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.SCENES_IN_USE_DELETE.replace(
        '{projectId}',
        params.projectId
      );

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    const queryParam = {};

    const response: Promise<IHttpResponse> = $ApiWrapper.delete(
      url,
      headersParam,
      queryParam,
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * 未作成シーンプレービュー要求
   * @param body
   * @param errorCallback
   */
  postStartRequestNotCreatedScenePreview(
    controlGroupId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.NOT_CREATED_SCENE_PREVIEW.replace(
        '{controlGroupId}',
        controlGroupId.toString()
      ).replace('{projectId}', params.projectId);

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    headersParam.isCredential = true;

    const response: Promise<IHttpResponse> = $ApiWrapper.post(
      url,
      headersParam,
      {},
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * 未合成シーンプレービュー要求
   * @param body
   * @param errorCallback
   */
  postStartRequestNotCompositionScenePreview(
    controlGroupId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.NOT_COMPOSITION_SCENE_PREVIEW.replace(
        '{controlGroupId}',
        controlGroupId.toString()
      ).replace('{projectId}', params.projectId);

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    headersParam.isCredential = true;

    const response: Promise<IHttpResponse> = $ApiWrapper.post(
      url,
      headersParam,
      {},
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }
  /**
   * 作成済シーンプレービュー要求
   * @param sceneId
   * @param body
   * @param errorCallback
   */
  postStartRequestCreatedScenePreview(
    controlGroupId: number,
    sceneId: number,
    body: any,
    errorCallback: any
  ): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.CREATED_SCENE_PREVIEW.replace(
        '{controlGroupId}',
        controlGroupId.toString()
      )
        .replace('{projectId}', params.projectId)
        .replace('{sceneId}', sceneId.toString());

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    headersParam.isCredential = true;

    const response: Promise<IHttpResponse> = $ApiWrapper.post(
      url,
      headersParam,
      {},
      body,
      maxRetryCount,
      errorCallback
    );

    return response;
  }

  /**
   * プレビュー終了要求
   * @param streamingProcessId
   * @param errorCallback
   * @returns
   */
  deleteRequestEndPreview(streamingProcessId: string, errorCallback: any): Promise<IHttpResponse> {
    const params = useParamsStore();
    const { $YOIEN_SERVER_CONFIG, $ApiWrapper, $getApiUrl } = useNuxtApp();

    const url =
      $getApiUrl() +
      $YOIEN_SERVER_CONFIG.YOIEN_INTERNAL_API_NAME.STOP_SCENE_PREVIEW.replace(
        '{projectId}',
        params.projectId
      ).replace('{streamingProcessId}', streamingProcessId);

    const maxRetryCount = $YOIEN_SERVER_CONFIG.YOIEN_SERVER.MAX_RETRY_COUNT;
    const headersParam = getYoienHeaderParams();
    headersParam.isCredential = true;

    const response: Promise<IHttpResponse> = $ApiWrapper.delete(
      url,
      headersParam,
      {},
      {},
      maxRetryCount,
      errorCallback
    );

    return response;
  }
}

export default defineNuxtPlugin(() => {
  return {
    provide: {
      yoienInternalApi: new YoienInternalApi(),
    },
  };
});
